import { Section } from "@/components/common/section/Section";
import styles from "./ValuesDescriptions.module.scss";
import {
  ValueDescription,
  ValueDescriptionProps,
} from "./valueDescription/ValueDescription";

export type ValuesDescriptionProps = {
  title: string;
  valuesDescriptions: ValueDescriptionProps[];
};

export const ValuesDescriptions = ({
  title,
  valuesDescriptions,
}: ValuesDescriptionProps) => {
  return (
    <Section containerStyle={styles.sectionColor}>
      <div className={styles.valuesDescriptions}>
        <p className={styles.title}>{title}</p>
        <div className={styles.content}>
          <div className={styles.valueDescription}>
            {valuesDescriptions.map((valueDescription, index) => (
              <ValueDescription {...valueDescription} key={index} />
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};
